// Copyright (c) 2026 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Button } from "react-bootstrap";

import { RoutedProps, withRouter } from "view/reactrouterinterceptor";
import { ActionType, IAction, raiseAction } from "actions";
import { IState } from "states/states";
import { SiteParameterHistoryEntry } from "graphql/api";

import FormattedDate from "view/comp/FormattedDate";
import FormattedTime from "view/comp/FormattedTime";

interface ISiteParametersProps {
  history: SiteParameterHistoryEntry[] | undefined;
}

const mapStateToProps = (state: IState) => {
  const props: ISiteParametersProps = {
    history: state.para.history,
  };
  return props;
};

interface ISiteParametersDispatch {
  onDownload: (timestamp: number) => void;
}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: ISiteParametersDispatch = {
    onDownload: (timestamp: number) => {
      dispatch(raiseAction(ActionType.ACT_DOWNLOAD_PARAMETER_REQ, timestamp));
    },
  };
  return dispatchProps;
};

class SiteParametersComponent extends React.Component<
  ISiteParametersProps & ISiteParametersDispatch & RoutedProps
> {
  public render() {
    return (
      <div id="siteparameters">
        <h1>
          <FormattedMessage id="Site Parameters" />
        </h1>
        {this.renderHistory()}
      </div>
    );
  }

  private renderHistory() {
    if (!this.props.history?.length) {
      return (
        <div className="text-muted">
          <FormattedMessage id="No parameter history available" />
        </div>
      );
    }
    return (
      <table style={{ backgroundColor: "white" }}>
        <thead>
          <tr>
            <th>
              <FormattedMessage id="Date" />
            </th>
            <th />
          </tr>
        </thead>
        <tbody>
          {this.props.history.map((entry) => (
            <tr key={entry.timestamp}>
              <td>
                <FormattedDate valueS={entry.timestamp} doZeroPadding={true} />{" "}
                <FormattedTime valueS={entry.timestamp} doZeroPadding={true} />
              </td>
              <td>
                <Button
                  variant="outline-success"
                  size="sm"
                  onClick={() => this.props.onDownload(entry.timestamp)}
                >
                  <FormattedMessage id="Download" /> (.epara)
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SiteParametersComponent));
